import './index.scss';
import Language from '../../i18n/Language';
import { Link } from "@shopify/polaris";
const t = Language;

const FooterTrustHelp = () => {

    return <>
        <div className="FooterTrustHelp">
            <p>{t("Learn more about")}&nbsp;<Link target='_blank' url="https://www.seowill.com/">SEOWILL</Link>&nbsp;&nbsp;{t("by")}&nbsp;<Link target='_blank' url="https://www.cwill.com/">CWILL</Link></p>
        </div>
        {/* <div className="FooterTrustHelp">
            <img src="/imgs/svg/logo/CW_SEOWILL.svg" width={116} height={32} alt="" />
            <div>
                <p>{t("Over 30000+ brands use SEOWILL to grow their business.")}</p>
                <p>{t("Learn more about")}&nbsp;<Link target='_blank' url="https://www.seowill.com/">SEOWILL</Link>&nbsp;&nbsp;{t("by")}&nbsp;<Link target='_blank' url="https://www.cwill.com/">CWILL</Link></p>
            </div>
            <img src="/imgs/Image/footer-trust.png" width={105} height={30} alt="" />
        </div>
        <div className='mobile_help_text'>
            <p>{t("Over 30000+ brands use SEOWILL to grow their business.")}</p>
            <p>{t("Learn more about")}&nbsp;<Link target='_blank' url="https://www.seowill.com/">SEOWILL</Link>&nbsp;&nbsp;{t("by")}&nbsp;<Link target='_blank' url="https://www.cwill.com/">CWILL</Link></p>
        </div> */}
    </>
}

export default FooterTrustHelp;